
import './App.css';
import '@fontsource/roboto/500.css';

function Contactus() {
  return (
    <>
      <section class="hero">

          <div class="container">

          <h1 class="display-4 fw-bold">
          Contact Us
          </h1>

          <p class="lead mt-3">
          We're here to help employers and skilled workers connect.
          Reach out to us anytime.
          </p>

          </div>

      </section>


      <section class="section">

          <div class="container">

              <div class="text-center mb-5">
              <h2 class="fw-bold">Corporate Offices</h2>
              <p class="text-muted">
              Visit our offices or get in touch with our support team.
              </p>
              </div>

          <div class="row g-4">



              <div class="col-lg-6">

              <div class="card office-card">

              <div class="office-header">
              <i class="bi bi-building"></i>
              Corporate Office – Dwarka, New Delhi
              </div>

              <div class="card-body">

              <div class="d-flex mb-4">

              <div class="contact-icon me-3">
              <i class="bi bi-geo-alt-fill"></i>
              </div>

              <div>
              <strong>Address</strong><br/>
              Ground Floor A,<br/>
              Sector 16 B, Dwarka,<br/>
              New Delhi – 110078<br/>
              India
              </div>

              </div>

              <div class="d-flex mb-3">

              <div class="contact-icon me-3">
              <i class="bi bi-telephone-fill"></i>
              </div>

              <div>
              <strong>Phone</strong><br/>
              +91 78385 40774, +91 9717 800805.
              </div>

              </div>

              <div class="d-flex">

              <div class="contact-icon me-3">
              <i class="bi bi-envelope-fill"></i>
              </div>

              <div>
              <strong>Email</strong><br/>
              labourchowk7@gmail.com <br/>          
              </div>

              </div>

              <a href="#" class="btn btn-primary mt-4 w-100">
              <i class="bi bi-geo-alt"></i>
              View on Google Maps
              </a>

              </div>

              </div>

              </div>

          <div class="col-lg-6">

          <div class="card office-card">

          <div class="office-header bg-success">
          <i class="bi bi-building"></i>
          Corporate Office – Greater Noida
          </div>

          <div class="card-body">

          <div class="d-flex mb-4">

          <div class="contact-icon me-3">
          <i class="bi bi-geo-alt-fill"></i>
          </div>

          <div>

          <strong>Address</strong><br/>
          Shop No. 7,<br/>
          Raipur Village,<br/>
          Greater Noida,<br/>
          Uttar Pradesh – 201310<br/>
          India

          </div>

          </div>

          <div class="d-flex mb-3">

          <div class="contact-icon me-3">
          <i class="bi bi-telephone-fill"></i>
          </div>

          <div>

          <strong>Phone</strong><br/>
          +91 85100 35195, +91 8483 003401.

          </div>

          </div>

          <div class="d-flex">

          <div class="contact-icon me-3">
          <i class="bi bi-envelope-fill"></i>
          </div>

          <div>

          <strong>Email</strong><br/>
          rajugupta5518@gmail.com<br/>        
          </div>

          </div>

          <a href="#" class="btn btn-success mt-4 w-100">
          <i class="bi bi-geo-alt"></i>
          View on Google Maps
          </a>

          </div>

          </div>

          </div>

          </div>

          </div>

      </section>

<section class="section bg-light">

<div class="container">

<div class="row">

<div class="col-lg-7">

<div class="contact-form">

<h3 class="mb-4">
Send us a Message
</h3>

<form>

<div class="row">

<div class="col-md-6 mb-3">
<input type="text"
class="form-control"
placeholder="Full Name"/>
</div>

<div class="col-md-6 mb-3">
<input type="email"
class="form-control"
placeholder="Email Address"/>
</div>

</div>

<div class="mb-3">
<input type="text"
class="form-control"
placeholder="Mobile Number"/>
</div>

<div class="mb-3">

<select class="form-select">

<option>Select Subject</option>

<option>Employer Support</option>

<option>Worker Registration</option>

<option>Business Partnership</option>

<option>Complaint</option>

<option>General Inquiry</option>

</select>

</div>

<div class="mb-3">

<textarea
class="form-control"
rows="5"
placeholder="Write your message..."></textarea>

</div>

<button class="btn btn-primary btn-lg">
<i class="bi bi-send-fill"></i>
Send Message
</button>

</form>

</div>

</div>

<div class="col-lg-5">

<div class="card office-card">

<div class="office-header">
Business Hours
</div>

<div class="card-body">

<p><strong>Monday - Saturday</strong></p>

<h5>07:00 AM – 10:00 PM</h5>

  <hr/>

<p><strong>Sunday</strong></p>

<h5>OPEN</h5>

<hr/>

<h5>Customer Support</h5>

<p class="text-muted">
Our team responds to most enquiries within 24 hours.
</p>

<hr/>

<h5>Follow Us</h5>

<div class="fs-2">

<i class="bi bi-facebook text-primary me-3"></i>

<i class="bi bi-instagram text-danger me-3"></i>

<i class="bi bi-linkedin text-primary me-3"></i>

<i class="bi bi-twitter-x"></i>

</div>

</div>

</div>

</div>

</div>

</div>

</section>

<footer class="footer-contact">

<div class="container text-center">

<h3>LabourChowk.in</h3>

<p class="mb-1">
Connecting Skilled Workers with Opportunities.
</p>

<p class="text-secondary">
© 2026 LabourChowk.in. All Rights Reserved.
</p>

</div>

</footer> 
    </>
    
  );
}

export default Contactus;


